import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";
// import sign from "../../../assest/images/Singn.png";
 import sign from "../../../assest/LogoAndFavicon/Hrsign/keelhrsign.png";
//import sign from "../../../assest/LogoAndFavicon/Hrsign/xperthrsign.jpg";
export const Page8 = () => {
  return (
    <ReusablePDFLayout>
      <div className="parentcls">
     
       

        <p className="bolds" style={{ margin: "20px 0" }}>
          Entire Contract:
        </p>
        <p className="para">
          The terms and conditions referred to in this letter constitute all of
          the terms and conditions of your employment and replace any prior
          understanding or contract between you and the employer.
        </p>

        <p className="para">
          The terms and conditions referred to in this contract may only be
          varied by a written contract signed by both you and Company.
        </p>

        <p className="bolds" style={{ margin: "20px 0" }}>
          Acceptance:
        </p>
        <p className="para">
          If you have any questions about the terms and conditions of
          employment, you may please contact the HR Department of the Company.
          <br />
          If you find the above terms favorable, you may please indicate your
          acceptance within Seven (07) business days of receipt of this letter
          by signing the duplicate copy of this letter and resending it back to
          the HR Department of the Company.
        </p>
        <p className="para" style={{ margin: "20px 0" }}>
          {/* For Keel Cyber Guardian Private Limited */}
          For EverGuard Insurance Broking Services Private Limited 
        </p>
        <div >
          <img src={sign} width={"180px"} />
        </div>
        <p className="bols" style={{marginTop:"20px"}}>Name of the Signing Authority People Partner</p>
      </div>
    </ReusablePDFLayout>
  );
};
